import { connect } from 'react-redux';
import { selectDesktopNavIsCollapsed } from 'features/Sidenav/selectors';
import FooterBar from './FooterBar';

export const mapStateToProps = state => ({
  desktopNavIsCollapsed: selectDesktopNavIsCollapsed(state),
});

export default connect(mapStateToProps)(FooterBar);
